module.exports = __webpack_public_path__ + "static/img/4856_phase_function_Paper_Points.020168b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4856_phase_function_Paper_Points.png
// module id = 8Nmf
// module chunks = 0